<template>
  <div class="col-sm-6 col-md-4 col-xl-3">
    <div class="my-4 text-center">
      <!-- <p class="text-muted">Center modal</p> -->
      <b-button v-b-modal.modal-center variant="primary" class="xs">
        Προσθήκη</b-button
      >
      <b-modal
        id="modal-center"
        centered
        title="Προσθήκη συσκευής"
        title-class="font-20"
        hide-footer
      >
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Προσθήκη συσκευής</h4>
              <b-spinner
                v-show="spinner"
                class="m-2"
                variant="primary"
                role="status"
              ></b-spinner>
              <b-alert
                v-show="alert.alertShow"
                show
                dismissible
                :variant="alert.alertVariant"
                >{{ alert.alertMsg }}</b-alert
              >
              <p class="card-title-desc">
                Συμπληρώστε την παρακάτω φόρμα για να προσθέσετε συσκευή
              </p>
              <form class="needs-validation" @submit.prevent="formCreateDevice">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="validationCustom01">Όνομα Συσκευής</label>
                      <input
                        id="validationCustom01"
                        type="text"
                        class="form-control"
                        placeholder="Ονομα Συσκευής"
                        required
                        v-model="device.deviceName"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="validationCustom02">IP</label>
                      <input
                        id="validationCustom02"
                        type="text"
                        class="form-control"
                        placeholder="IP Συσκευής"
                        required
                        v-model="device.deviceIP"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="validationCustom03">Port</label>
                      <input
                        id="validationCustom03"
                        type="text"
                        class="form-control"
                        placeholder="Port"
                        required
                        v-model="device.devicePort"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-check mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="invalidCheck"
                    checked
                    v-model="device.active"
                  />
                  <label class="form-check-label" for="invalidCheck">
                    Ενεργό
                  </label>
                </div>

                <button class="btn btn-primary" type="submit">
                  Προσθήκη
                </button>
              </form>
            </div>
          </div>
          <!-- end card -->
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import session from "../../../../../api/session";
import { eventCreate } from "../../../../../eventspy";
export default {
  name: "CreateDevice",
  data() {
    return {
      device: {
        deviceName: "",
        deviceIP: "",
        devicePort: 4370,
        active: true,
      },
      spinner: false,
      alert: {
        alertShow: false,
        alertMsg: "",
        alertVariant: "success",
      },
    };
  },
  methods: {
    async formCreateDevice() {
      this.spinner = true;
      await session
        .post("api/devices/add/", {
          device_name: this.device.deviceName,
          device_ip: this.device.deviceIP,
          device_port: this.device.devicePort,
          active: this.device.active,
        })
        .then(() => {
          this.spinner = false;
          this.alert.alertShow = true;
          this.alert.alertVariant = "success";
          this.alert.alertMsg = "Η συσκευή προστέθηκε επιτυχώς!";

          this.$emit("deviceCreated");

          eventCreate(
            `Πρόσθεσε την συσκευή 
            device_name :${this.device.deviceName}
            device_ip: ${this.device.deviceIP}, 
            device_port: ${this.device.devicePort},
            active: ${this.device.active} `,
            1
          );

          this.setDefaultDeviceForm();
          setTimeout(() => {
            this.alert.alertShow = false;
            this.alert.alertMsg = "";
            this.$bvModal.hide("modal-center");
          }, 2000);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinner = false;
          this.alert.alertShow = true;
          this.alert.alertVariant = "dnager";
          this.alert.alertMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          this.setDefaultDeviceForm();
          setTimeout(() => {
            this.alert.alertShow = false;
            this.alert.alertMsg = "";
            this.$bvModal.hide("modal-center");
          }, 2000);
        });
    },

    setDefaultDeviceForm() {
      this.device.deviceName = "";
      this.device.deviceIP = "";
      this.spinner = false;
    },
  },
};
</script>
